import { Pages } from "modules/BookingCommon/common/constants"

export const PAGES = [Pages.FORM, Pages.PAYMENT, Pages.SUCCESS]
